import { useEffect, useState } from 'react'
import Button from '../shared/Button'
import { useDispatch } from 'react-redux'
import { useAppContext } from '../../../../context/AppContext'
import Spinner from '../shared/Spinner'
import ProductCard from './ProductCard'
import { findIfRecipeInOrder } from '@/functions/productControl/productControl'
import { openModalAsNewPage } from '@/functions/modal/modalControls'
import { setProductInfo } from '@/redux/actions/modalAction'
import { useRouter } from 'next/router'

const Product = ({ productData, rowDisplay, color, extraAction, promoTag, wareCategoryId }) => {
    let router = useRouter()
    let order = useAppContext()
    let dispatch = useDispatch()

    const isOrderLocked = order && order.order.isLocked

    const [loading, setLoading] = useState(false)
    const [dynamicData, setDynamicData] = useState(0)

    const addProductToOrder = async () => {
        if (!isOrderLocked) {
            setLoading(true)
            if (extraAction) {
                extraAction(productData)
                setLoading(false)
            } else {
                openModalAsNewPage(router, productData.id)

                dispatch(
                    setProductInfo({
                        wareCategoryId: wareCategoryId,
                        promoTag: promoTag ? promoTag : null
                    })
                )
            }
        }
    }

    useEffect(() => {
        const data = findIfRecipeInOrder(productData, order)
        setDynamicData(data)
    }, [order, productData])

    useEffect(() => {
        setLoading(false)
    }, [order])

    function generateButtons() {
        //const buttonText = dynamicData === 0 || dynamicData === undefined ? '+ Přidat' : `+ Další (${dynamicData})`
        const buttonText = '+ Přidat '
        return (
            <>
                <Button
                    disabled={isOrderLocked}
                    title={loading ? <Spinner color={color} backgroundColor={'rgb(229, 231, 235)'} /> : buttonText}
                    bgColor={'background'}
                    variant={'solid'}
                    full={false}
                />
            </>
        )
    }

    return (
        <>
            <ProductCard
                image={productData.image}
                title={productData.nameLabel}
                allergens={productData.allergens}
                imagePreview={productData.imagePreview}
                subTitle={productData.descriptionLabel === '' ? true : productData.descriptionLabel}
                price={productData.price.value + ' ' + productData.price.currency.code}
                rowDisplay={rowDisplay}
                buttonSection={!productData.soldOut && generateButtons()}
                color={color}
                productCardClick={addProductToOrder}
                productBadge={dynamicData !== 0 ? dynamicData : null}
                sold={productData.soldOut}
            />
        </>
    )
}
export default Product
